import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';

import {Link} from 'react-router';
import AppBlock from '../components/AppBlock';
import Title from '../components/Form/Title';

class TextPage extends Component {
  render() {
    const {intl, pointerEventsValue, title, content, backLinkParams} = this.props;

    return (
      <AppBlock>
        <Title
          title={title}
          backLink={
            backLinkParams && (
              <Link
                className="back-link"
                style={{pointerEvents: pointerEventsValue}}
                to={backLinkParams}
              >
                {intl.messages['app.back']}
              </Link>
            )
          }
        />

        {content}
      </AppBlock>
    );
  }
}

TextPage.propTypes = {
  intl: PropTypes.object,
  pointerEventsValue: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  backLinkParams: PropTypes.object
};

function mapStateToProps(state) {
  return {
    ...state
  };
}

export default injectIntl(connect(mapStateToProps)(TextPage));



// WEBPACK FOOTER //
// ./pages/TextPage.jsx